module.exports = __webpack_public_path__ + "assets/img/632223.0c2900f2.png";